import { useState } from "react";
import { XYZ_DEX_NAME } from "../../lib/hyperliquid.ts";

export function useCoinLogo(coin: string, dex?: string) {
	const logoCoin = dex === XYZ_DEX_NAME ? `${XYZ_DEX_NAME}:${coin}` : coin;

	const [errorCoin, setErrorCoin] = useState("");
	const logoFailed = errorCoin === logoCoin;
	const logoSrc = `https://app.hyperliquid.xyz/coins/${logoCoin}.svg`;
	const onLogoError = () => setErrorCoin(logoCoin);

	return { logoSrc, logoFailed, onLogoError };
}
